import { Injectable } from '@angular/core'
import { Subject } from 'rxjs/Subject'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { clientTop } from '../../models/clientTop'
import { StateServices } from './state.services'
import * as moment from 'moment'
import Constants from '@commons/Constants'
import { MultipleImageHelper } from '@helpers/mutiple-image.helper'

@Injectable()

export class ClientTopServices {
    tabName: any
    arrCopy: any
    arrAllClientTop: any[] = []
    index: any
    checkChangeData: boolean = false
    checkActiveDatepickker: any
    checkActiveDatepickkerWhenCancel: any
    arrSimulation: any = {}

    returnTabName: any

    arrAll: any
    changeInit: any = {}
    page: any = ''
    hash: any[] = []
    imageIndexs: any[] = []

    constructor(private stateServices: StateServices) {
        this.changeInit['init'] = 'init'
    }

    // Observable string sources
    private emitChangeSource = new Subject<any>()
    private emitChangeSourceParent = new Subject<any>()
    // Observable string streams
    changeEmitted$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedSource$ = this.emitChangeSourceParent.asObservable()
    changeEmittedAllArrClientTo$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmitImageSmileEdited: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedStatus$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedIndex$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedListTopImageData$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedTabName$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedArrCopy$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedcount$: BehaviorSubject<any> = new BehaviorSubject(0)
    changeEmittedSlider$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedValueSlider$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedHash$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedNoteList$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedNote$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmitChangeInfoUrlChange$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmitGetFaceImage$: BehaviorSubject<any> = new BehaviorSubject(null)
    ChangeRefreshEmittedSlider$: BehaviorSubject<any> = new BehaviorSubject(null)
    ChangeIndexToGetNoteEmittedSlider$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedStyle$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedrefreshArr$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmiitedIsCreated$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedArrSimulation$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedArrSlideShow$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedViewDetailUser$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmiitedArrSimulation$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmiitedArrSlideshow$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmiitedActiveIndex$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmiitedPreventationName$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmiitedInit$: BehaviorSubject<any> = new BehaviorSubject(this.changeInit)

    changeEmiitedPage$: BehaviorSubject<any> = new BehaviorSubject(this.changeInit)
    arrayDataCopy

    canvasModalLoading$: BehaviorSubject<any> = new BehaviorSubject(null)

    cancelEmittedBtn$: BehaviorSubject<any> = new BehaviorSubject(null)

    settingEmitData$: BehaviorSubject<any> = new BehaviorSubject(null)
    previousIndex = 0
    slideshowActive = false
    changeEmittedUploadImageIndex$: BehaviorSubject<any> = new BehaviorSubject([])
    emitCancelBtn(status) {
        this.cancelEmittedBtn$.next(status)
    }

    updatePreviousIndex(index) {
        this.previousIndex = index
    }

    // Service message commands
    emitChangeIsCreated(change: any) {
        this.changeEmiitedIsCreated$.next(change)
    }

    emitChangePage(change: any) {
        this.page = change
        this.changeEmiitedPage$.next(change)
    }

    returnPage() {
        return this.page
    }

    resetPage() {
        this.page = ''
        this.changeEmiitedPage$.next(null)
    }

    emitChangeInit(change: any = this.changeInit) {
        this.changeEmiitedInit$.next(change)
    }

    resetChangeInit() {
        this.changeEmiitedInit$.next(this.changeInit)
    }

    emitChangePreventationName(change: any) {
        this.changeEmiitedPreventationName$.next(change)
    }

    emitChangeActiveIndex(change: any) {
        this.changeEmiitedActiveIndex$.next(change)
    }

    emitChangeViewDetailUser(change: any) {
        this.changeEmittedViewDetailUser$.next(change)
    }

    emitChangeNoteList(change: any) {
        this.changeEmittedNoteList$.next(change)
    }

    emitChangeNote(change: any) {
        this.changeEmittedNote$.next(change)
    }

    emitChangeInfoUrlChange(change: any) {
        this.changeEmitChangeInfoUrlChange$.next(change)
    }

    emitGetFaceImage(change: any) {
        this.changeEmitGetFaceImage$.next(change)
    }

    emitChangeSlideshow(change: any) {
        this.changeEmittedArrSlideShow$.next(change)
    }

    emitChangeArrSimulation(change: any) {
        this.arrSimulation = change
        this.changeEmittedArrSimulation$.next(change)
    }

    returnArrSimulation() {
        return this.arrSimulation
    }

    emitChangeRefreshArr(change: any) {
        this.changeEmittedrefreshArr$.next(change)
    }

    emitChangeStyle(change: any) {
        this.changeEmittedStyle$.next(change)
    }

    emitChangeHash(change: any) {
        this.changeEmittedHash$.next(change)
    }

    emitChangeValueSlider(change: any) {
        this.changeEmittedValueSlider$.next(change)
    }

    emitChangeSlider(change: any) {
        this.changeEmittedSlider$.next(change)
    }

    emitChange(change: any) {
        this.changeEmitted$.next(change)
    }

    emitChangeRefresh(change: any) {
        this.ChangeRefreshEmittedSlider$.next(change)
    }

    emitChangeIndexToGetNote(change: any) {
        this.ChangeIndexToGetNoteEmittedSlider$.next(change)
    }

    emitChangeParent(change: any) {
        this.emitChangeSourceParent.next(change)
    }

    emitChangeChangeStatus(data: any) {
        this.changeEmittedStatus$.next(data)
    }

    emitChangeAllArrClientTop(data: any) {
        this.checkChangeData = true
        if (data != null && data['checkChange'] != undefined) {
            if (data['checkChange'] === true) {
                this.checkChangeData = true
            } else if ((data['checkChange'] === false)) {
                this.checkChangeData = false
            } else {
                this.checkChangeData = true
            }
        } else {
            this.checkChangeData = false
        }
        if (data != null && data['registration'] != undefined) {
            this.arrAllClientTop = data['registration']
        }
        this.arrAll = data
        this.changeEmittedAllArrClientTo$.next(data)
    }

    emitSimpleEdit(data: any) {
        if (data && this.arrAll && this.arrAll.registration && this.arrAll.registration[this.index]) {
            const imageObject = this.arrAll.registration[this.index]
            const imageIndex = data.imageIndex
            const images = MultipleImageHelper.getRelationRegistrationImage(this.tabName, imageIndex)
            images.forEach(imagePosition => {
                const image = imageObject[imagePosition.position][imagePosition.index]
                image.style = data.style
                image.matrix = Constants.IMAGE_MATRIX_DEFAULT
            })
            const emitData = {
                imageIndex: imageIndex,
                emitArrAll: this.arrAll,
                imageItem: data,
            }
            this.changeEmitImageSmileEdited.next(emitData)
        }
    }

    resetAllArrClientTop() {
        this.arrAll = undefined
        this.arrAllClientTop = undefined
        this.changeEmittedAllArrClientTo$.next(null)
    }

    comparison(json1: any = {}, json2: any = {}) {
        let key: any = ''
        // if (json1['checkChange'] == json2['checkChange']) {
        //   return true;
        // } else {
        //   return false;
        // }
        if (json1['registration'] != undefined) {
            if (json2['registration'] != undefined) {
                key = 'registration'
            } else {
                return false
            }
        } else if (json1['slideshow'] != undefined) {
            if (json2['slideshow'] != undefined) {
                key = 'slideshow'
            } else {
                return false
            }
        } else if (json1['comparision'] != undefined) {
            if (json2['comparision'] != undefined) {
                key = 'comparision'
            } else {
                return false
            }
        }
        if (key != '') {
            const array1: any[] = json1[key]
            const array2: any[] = json2[key]
            let arrTmp: any[] = []
            if (array1.length > 0 && array2.length > 0) {
                array1.forEach(el1 => {
                    arrTmp = array2.filter(el2 => {
                        return JSON.stringify(el1) == JSON.stringify(el2)
                    })
                })
                if (arrTmp.length == array2.length) {
                    return true
                }
                return false
            }
        }
        return false
    }

    getAllArrClientTop() {
        return this.arrAllClientTop
    }

    returnArrAll() {
        return this.arrAll
    }

    emitChangeIndex(data: any) {
        if (data != null && data['index'] != undefined) {
            this.index = data['index']
            this.imageIndexs.unshift(data)
            if (window['imageTimeOut']) {
                clearTimeout(window['imageTimeOut'])
                window['imageTimeOut'] = null
            }

            window['imageTimeOut'] = setTimeout(() => {
                let imageIndex
                if (this.imageIndexs[1] && this.imageIndexs[1].updateIndex) {
                    imageIndex = this.imageIndexs[1]
                } else {
                    imageIndex = this.imageIndexs[0]
                }
                this.changeEmittedIndex$.next(imageIndex)
                this.imageIndexs = []
                window['imageTimeOut'] = null
            }, 200)

        }
    }

    resetIndex() {
        this.index = undefined
        this.changeEmittedIndex$.next(null)
    }

    getIndex() {
        return this.index
    }

    emitChangeListTopImageData(data: any) {
        this.changeEmittedListTopImageData$.next(data)
    }

    emitChangeTabName(data: any) {
        if (data != null && data['tabName'] != undefined) {
            if (this.tabName != data['tabName']) {
                this.tabName = data['tabName']
                this.changeEmittedTabName$.next(data)
                this.returnTabName = jQuery.extend(true, {}, data)
                this.stateServices.emitChangeTabName(this.tabName)
            }
        } else {
            this.tabName = ''
        }
    }

    resetTabName() {
        this.returnTabName = undefined
        this.tabName = undefined
        this.changeEmittedTabName$.next({ reset: true })
    }

    functReturnTabName() {
        return this.returnTabName
    }

    getTabName() {
        return this.tabName
    }

    emitChangeArrCopy(data: any = []) {
        this.arrCopy = data
        this.changeEmittedArrCopy$.next(data)
        this.arrayDataCopy = data
    }

    getArrCopy() {
        return this.arrCopy
    }

    emitChangeCount(data: any = {}) {
        this.changeEmittedcount$.next(data)
    }

    showClientArrayTop(ArrayTop) {
        const aray = new clientTop()
        if (ArrayTop === 'arrListCategory') {
            return aray.arrListCategory
        } else {
            return ''
        }
    }

    changecheckDataAfterConfirm(data: boolean) {
        if (data === false) {
            this.checkChangeData = false
        } else {
            this.checkChangeData = true
        }
    }

    returnCheckChange() {
        return this.checkChangeData
    }

    changeActiveDatepickerAfterConfirm(data) {
        if (data === false) {
            this.checkActiveDatepickker = false
        } else if (data === true) {
            this.checkActiveDatepickker = true
        } else if (data === 'Show') {
            this.checkActiveDatepickkerWhenCancel = true
        } else if (data === 'not Show') {
            this.checkActiveDatepickkerWhenCancel = false
        }
    }

    getCheckActiveDatepickkerWhenCancel() {
        return this.checkActiveDatepickkerWhenCancel
    }

    getCheckActiveDatepickker() {
        return this.checkActiveDatepickker
    }

    changeDateStringToDecoe(arrRegistration) {
        const offset = new Date().getTimezoneOffset()
        for (let j = 0; j < arrRegistration.length; j++) {
            arrRegistration[j]['dateStringToInit'] = moment(arrRegistration[j]['dateString']).add(Math.abs(offset), 'ms').valueOf()
        }
        return arrRegistration
    }

    changeArrImg(arrImg,page,index){
        if(page== "slideshow"){
            this.changeEmittedAllArrClientTo$['_value'].arrTmpArrClientTop.splice(index,1)
        }
    }
    
    emitSettingData(data) {
        this.settingEmitData$.next(data);
    }

    emitUploadImageIndex(imgIndex) {
        /**
         * pushing image index to array is not necessary because this array
         * also stores the indexes of all images uploaded before,
         * while we only care about the index of the new uploaded image
         */
        // const data = this.changeEmittedUploadImageIndex$.getValue().concat([item])
        // this.changeEmittedUploadImageIndex$.next(data)

        // only track new upload image index
        this.changeEmittedUploadImageIndex$.next(imgIndex)
    }
    
    resetListImageTemporary() {
        this.changeEmittedUploadImageIndex$.next(-1)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/ClientTop.services.ts